import './App.css';
import React from "react";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className = "container">
        <header className="App-header">
          <h1>Dictionary App</h1>
        </header>
        <main>
          <Dictionary defaultKeyword="Hello"/>
        </main>
        <footer>
          <a href="https://github.com/edc98/dictionary-app" className="github-link">Open-source Code </a> 
          by Emma Duensing
        </footer>
      </div>
    </div>
  );
}
